import { useMutation } from '@tanstack/react-query'

import { getSwiftlaneUserGroupsQueryKey } from '@/api/keyless/swiftlane/get-swiftlane-user-groups'
import { integrationAPI } from '@/api/new-api'
import { resetQueries } from '@/utils'

type UpdateSwiftlaneConnectionRequest = {
  buildingId: number
  authToken: string
  swiftlaneAccountName: string
  config: string
}

const updateSwiftlaneConnection = async (data: UpdateSwiftlaneConnectionRequest) => {
  const response = await integrationAPI.post('/swiftlane', data)
  return response.data
}

export const useUpdateSwiftlaneConnection = () =>
  useMutation({
    mutationFn: updateSwiftlaneConnection,
    onSuccess: async (_data, variables) => {
      await resetQueries([getSwiftlaneUserGroupsQueryKey({ buildingId: variables.buildingId })])
    },
  })
